import { LOCALE_ID, NgModule } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
registerLocaleData(localeAr, 'ar-u-nu-latn');
import { CommonModule } from '@angular/common';

// Helpers
import { MaterialModule } from '../helpers/material-modules';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownDirective } from '../helpers/drop-down.directive';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from '../helpers/CustomPaginatorConfiguration';
import { DirtyCheckGuard } from '../helpers/CanDeactivate/dirty-check.guard';


import { RouterModule } from '@angular/router';
import { ShortNamePipe } from '../helpers/short-name.pipe';
import { EmptyStateComponent } from '../components/empty-state/empty-state.component';

import { NgSelectModule } from '@ng-select/ng-select';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { SanitizeHtmlPipePipe } from '../helpers/sanitize-html-pipe.pipe';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment } from 'public/environments/environment';
import { AccessControlDirective } from '../helpers/access-control.directive';
import { OnlynumberDirective } from '../helpers/onlynumber.directive';
import { OnlyenglishDirective } from '../helpers/onlyenglish.directive';
import { OnlyarabicDirective } from '../helpers/onlyarabic.directive';
import { TreeSelectionComponent } from '../components/tree-selection/tree-selection.component';
import { FilesViewerComponent } from '../components/files-viewer/files-viewer.component';
import { FileManagerComponent } from '../components/file-manager/file-manager.component';
import { TimeAgoPipe } from '../helpers/time-ago.pipe';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { DndDirective } from '../helpers/dnd.directive';
import { SafePipe } from '../helpers/SafePipe';
import { FileUploadDirective } from '../helpers/file-upload.directive';
import { PercentageDirective } from '../helpers/percentage.directive';
import { SelectHasSearchComponent } from '../components/select-has-search/select-has-search.component';
import { TruncateTextPipe } from '../helpers/truncate-text.pipe';
import { AutoOpenDatepickerDirective } from '../helpers/AutoOpenDatepicker.directive';
import { OnlyDecimalDirective } from '../helpers/appOnlyDecimal.directive';
import { SanitizeSrcPipe } from '../helpers/sanitize-url-pipe.pipe';
import { TreeSelectionEntitiesComponent } from '../components/tree-selection-entities/tree-selection-entities.component';
import { TreeRadioComponent } from '../components/tree-radio/tree-radio.component';
import { FileManagerV2Component } from '../components/file-manager-v2/file-manager-v2.component';
import { ImageControlComponent } from '../components/image-control/image-control.component';
import { TreeFieldRadioComponent } from '../components/tree-field-radio/tree-field-radio.component';
import { CropperDialogComponent } from '../components/image-control/cropper-dialog/cropper-dialog.component';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ComplaintActionsComponent } from '../components/complaints/components/complaint-details/complaint-actions/complaint-actions.component';
import { ComplaintAttachmentsComponent } from '../components/complaints/components/complaint-details/complaint-attachments/complaint-attachments.component';
import { ComplaintDetailsCommentsComponent } from '../components/complaints/components/complaint-details/complaint-details-comments/complaint-details-comments.component';
import { ComplaintCommentControlsComponent } from '../components/complaints/components/complaint-details/complaint-details-comments/complaint-comment-controls/complaint-comment-controls.component';
import { TimeRemainingDirective } from '../helpers/TimeRemaining.directive';
import { LockBodyScrollDirective } from '../helpers/lock-body-scroll.directive';
import { ErrorComponent } from '../pages/error/error.component';
import { DecimalPercentageDirective } from '../helpers/decimalPercentage.directive';
import { DisableWheelDirective } from '../helpers/disable-wheel.directive';
import { ChartStatisticComponent } from '../components/chart-statistic/chart-statistic.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { HorizontalConfirmationComponent } from '../components/horizontal-confirmation/horizontal-confirmation.component';
import { SidenavOverComponent } from '../components/sidenav-over/sidenav-over.component';
import { CourseDurationProgressComponent } from '../components/courses/course-duration-progress/course-duration-progress.component';
import { TrainerDetailsComponent } from '../components/courses/trainer-details/trainer-details.component';
import { AttachmentDetailsComponent } from '../components/attachment-details/attachment-details.component';
import { LightGalleryVideoComponent } from '../components/light-gallery-video/light-gallery-video.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TimeZoneUtcPipe } from '../helpers/time-zone-utc.pipe';
import { FilesDialogComponent } from '../components/files-dialog/files-dialog.component';
import { RatingComponent } from '../components/rating/rating.component';
import { ExamPreviewComponent } from '../components/exam/exam-preview/exam-preview.component';
import { ExamConfirmationComponent } from '../components/exam/exam-preview/exam-confirmation/exam-confirmation.component';
import { CounterDirective } from '../helpers/counter.directive';
import { ChatComponent } from '../modules/courses/chat/chat.component';
import { SearchResultComponent } from '../components/search-result/search-result.component';
import { VideoUrlPlayerComponent } from '../components/video-url-player/video-url-player.component';
import { PdfViewerComponent } from '../components/pdf-viewer/pdf-viewer.component';
import { VideoPlayerComponent } from '../components/video-player/video-player.component';
import { DateSuffixPipe } from '../helpers/date-suffix.pipe';
import { AssessmentResultsPathologistsComponent } from '../modules/courses/assessment-results-pathologists/assessment-results-pathologists.component';
import { CoursePlagiarismProcessComponent } from '../modules/courses/course-plagiarism-process/course-plagiarism-process.component';
import { EfinanceFormComponent } from '../components/efinance-form/efinance-form.component';
import { PaymentCardFormComponent } from '../components/efinance-form/payment-card-form/payment-card-form.component';
import { SelectWithSearchComponent } from '../components/select-with-search/select-with-search.component';
import { PaginationCustomComponent } from '../components/pagination-custom/pagination-custom.component';

const directives = [
  OnlynumberDirective,
  OnlyDecimalDirective,
  DropDownDirective,
  AccessControlDirective,
  OnlyenglishDirective,
  OnlyarabicDirective,
  InfiniteScrollDirective,
  DndDirective,
  FileUploadDirective,
  PercentageDirective,
  AutoOpenDatepickerDirective,
  TimeRemainingDirective,
  LockBodyScrollDirective,
  DecimalPercentageDirective,
  DisableWheelDirective,
  CounterDirective
];
const pipes = [
  ShortNamePipe,
  TimeAgoPipe,
  SanitizeHtmlPipePipe,
  SanitizeSrcPipe,
  SafePipe,
  TruncateTextPipe,
  TimeZoneUtcPipe,
  DateSuffixPipe
]

const Components = [
  EmptyStateComponent,
  TreeSelectionComponent,
  FilesViewerComponent,
  FileManagerComponent,
  SelectHasSearchComponent,
  TreeSelectionEntitiesComponent,
  TreeRadioComponent,
  FileManagerV2Component,
  ImageControlComponent,
  CropperDialogComponent,
  TreeFieldRadioComponent,
  ErrorComponent,
  //Complaint
  ComplaintActionsComponent,
  ComplaintAttachmentsComponent,
  ComplaintDetailsCommentsComponent,
  ComplaintCommentControlsComponent,

  ChartStatisticComponent,
  ConfirmationDialogComponent,
  HorizontalConfirmationComponent,
  SidenavOverComponent,
  AttachmentDetailsComponent,
  LightGalleryVideoComponent,

  // courses
  CourseDurationProgressComponent,
  TrainerDetailsComponent,
  FilesDialogComponent,
  RatingComponent,
  ExamPreviewComponent,
  ExamConfirmationComponent,
  ChatComponent,
  SearchResultComponent,
  VideoUrlPlayerComponent,
  PdfViewerComponent,
  VideoPlayerComponent,
  AssessmentResultsPathologistsComponent,
  CoursePlagiarismProcessComponent,

  // payment
  PaymentCardFormComponent,
  EfinanceFormComponent,

  // certificate
  SelectWithSearchComponent,
  PaginationCustomComponent
];

const modules = [
  PdfViewerModule
]

@NgModule({
  declarations: [
    Components,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    MaterialModule,
    LottieComponent,
    RecaptchaModule,
    NgxChartsModule,
    TranslateModule.forChild({}),
    directives,
    pipes,
    ImageCropperComponent,
    modules
  ],
  exports: [
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    TranslateModule,
    RecaptchaModule,
    NgxChartsModule,
    directives,
    pipes,
    Components,
    modules
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: localStorage.getItem('language') === 'ar' ? 'ar-u-nu-latn' : 'en-US' },
    DirtyCheckGuard,
    provideLottieOptions({ player: () => import('lottie-web') }),
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.googleSiteKey,
        useValue: localStorage.getItem('language') || 'ar'
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: () => localStorage.getItem('language') || 'ar',
    },
  ]
})
export class SharedLibModule { }
